import mainViewMixin from './mainViewMixin';
export default {
  name: 'ViewNiotaClassicDashboards',
  mixins: [mainViewMixin],
  data: function () {
    return {
      dburl: 'https://grafana.stage.niota.io/'
    };
  }
};